angular.module('jotApp').directive('tableScrollDetection', function () {
    return function () {
       $('.table-scrollable-vertical').on('scroll', function (){
           $("body > .dropdown-menu").hide();
       })
    };
});
